import { FleekError } from './FleekError';

type GitRepoByNameAndOwnerNotFoundErrorOptions = {
  repo: string;
  owner: string;
};

export class GitRepoByNameAndOwnerNotFoundError extends FleekError<GitRepoByNameAndOwnerNotFoundErrorOptions> {
  public name = 'GitRepoByNameAndOwnerNotFoundError';

  toString = () => `Git repo "${this.data.owner}/${this.data.repo}" not found`;
}
